module.exports = __webpack_public_path__ + "static/media/result.f33374eb.svg";